export default {
    namespaced: true,
    state: {
        user: null,
        programs: [],
        states: [],
        counties: [],
        permissions: {
            auditor: false,
            pm: false,
            manager: false,
            admin: false,
            root: false,
            household: false,
            debtor: false,
            processor: false,
        },
        env: {
            APPLY_OPEN: process.env.MIX_APPLY_OPEN,
            ALT_OPEN: process.env.MIX_ALT_OPEN,
            ALT_WAITLIST: process.env.MIX_ALT_WAITLIST,
            PROGRAM_NAME: process.env.MIX_PROGRAM_NAME,
            PROGRAM_URL: process.env.MIX_PROGRAM_URL,
            AGENCY_NAME: process.env.MIX_AGENCY_NAME,
            AGENCY_BRAND_GUIDELINE: process.env.AGENCY_BRAND_GUIDELINE,
            AGENCY_SHORT_NAME: process.env.MIX_AGENCY_SHORT_NAME,
            AGENCY_SITE: process.env.MIX_AGENCY_SITE,
            FAVICON: process.env.MIX_FAVICON,
            PRIMARY_COLOR: process.env.MIX_PRIMARY_COLOR,
            PUBLIC_PHONE: process.env.MIX_PUBLIC_PHONE,
            PUBLIC_EMAIL: process.env.MIX_PUBLIC_EMAIL,
            PUBLIC_FAX: process.env.MIX_PUBLIC_FAX,
            PUBLIC_STREET: process.env.MIX_PUBLIC_STREET,
            PUBLIC_CITY: process.env.MIX_PUBLIC_CITY,
            PUBLIC_STATE: process.env.MIX_PUBLIC_STATE,
            PUBLIC_ZIP: process.env.MIX_PUBLIC_ZIP,
            PUBLIC_LOGO: process.env.MIX_PUBLIC_LOGO,
            USE_LAYOUT_SET: process.env.MIX_USE_LAYOUT_SET,
            USE_ZOHO: process.env.MIX_USE_ZOHO,
            WAITLIST: process.env.MIX_WAITLIST,
            GOOGLE_API_KEY: process.env.GOOGLE_API_KEY,
        }
    },
    mutations: {
        SET_USER: (state, payload) => state.user = payload.user,
        SET_PROGRAMS: (state, payload) => state.programs = payload,
        SET_PERMISSIONS: (state, payload) => state.permissions = payload.permissions,
        SET_STATES: (state, payload) => state.states = payload.states,
        SET_COUNTIES: (state, payload) => state.counties = payload.counties,
    },
    actions: {
        fetchUser({commit}) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/hope/me`).then(res => {
                    commit('SET_USER', { user: res.data.user });
                    commit('SET_PERMISSIONS', { permissions: res.data.permissions });
                    commit('SET_STATES', { states: res.data.states });
                    commit('SET_COUNTIES', { counties: res.data.counties });
                    resolve(res.data)
                }).catch(e => {
                    reject(e)
                })
            });
        },
        getUser({commit}) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/hope/me`).then(res => {
                    commit('SET_USER', { user: res.data.user });
                    commit('SET_PERMISSIONS', { permissions: res.data.permissions });
                    commit('SET_STATES', { states: res.data.states });
                    commit('SET_COUNTIES', { counties: res.data.counties });
                    resolve(res.data)
                }).catch(e => {
                    reject(e)
                })
            });
        },
        setUser({commit}, payload) {
            commit('SET_USER', payload);
        },

    },
    getters: {
        user: (state) => state.user,
        permissions: (state) => state.permissions,
    }
}
